
(function () {
  const initializedRoots = new WeakSet();

  function initDelayedShipping(root) {
    if (!root || initializedRoots.has(root)) return;

    const note = root.querySelector('[data-delayed-note]');
    const dataEl = root.querySelector('script[data-delayed-inventory]');
    const idInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (!note || !dataEl || !idInput) return;

    let inventory;
    try {
      inventory = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Delayed shipping: cannot parse JSON', e);
      return;
    }

    function showNoteFor(variantId) {
      const info = inventory[String(variantId)];
      if (!info) {
        note.style.display = 'none';
        return;
      }

      if (info.available && info.inventory_quantity <= 0) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
      }
    }

    let lastId = idInput.value;
    if (lastId) showNoteFor(lastId);

    root.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      lastId = variant.id;
      showNoteFor(variant.id);
    });

    idInput.addEventListener('change', () => {
      if (idInput.value !== lastId) {
        lastId = idInput.value;
        showNoteFor(lastId);
      }
    });

    const interval = setInterval(() => {
      if (!document.body.contains(root)) {
        clearInterval(interval);
        return;
      }
      if (idInput.value !== lastId) {
        lastId = idInput.value;
        showNoteFor(lastId);
      }
    }, 200);

    initializedRoots.add(root);
  }

  function initAllExisting() {
    document.querySelectorAll('[data-delayed-note]').forEach((noteEl) => {
      const root =
        noteEl.closest('product-info') ||
        noteEl.closest('[data-section]') ||
        noteEl.parentElement;
      initDelayedShipping(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAllExisting();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('[data-delayed-note]')) {
            const root =
              node.closest('product-info') ||
              node.closest('[data-section]') ||
              node.parentElement;
            initDelayedShipping(root);
            return;
          }

          const nested = node.querySelector?.('[data-delayed-note]');
          if (nested) {
            const root =
              nested.closest('product-info') ||
              nested.closest('[data-section]') ||
              nested.parentElement;
            initDelayedShipping(root);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
